<template>
  <div class="index">
    <el-container class="container">
      <el-aside width="auto">
        <AppMenu/>
      </el-aside>
      <el-container class="leftContainer">
        <el-header height="3vw" class="header"><Header/></el-header>
        <el-main class="mian">
          <keep-alive :include="$store.state.cachePages">
            <router-view></router-view>
          </keep-alive>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import AppMenu from '../components/menu/menu.component';
import Header from '../components/header/userMenu.component';
export default {
  name: 'index',
  components: { AppMenu, Header },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
  },
  mounted() {
  }
}
</script>

<style scoped>
.index {
  height: 100%;
  width: 100%;
}
.container {
  height: 100%;
}
.header {
  display: flex;
  background: #fff;
  box-shadow: 0px 1px 5px 0px
		rgba(195, 188, 183, 0.28);
}

.leftContainer {
  background: #e4ebf2;
}
.mian > div {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
</style>
